
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { CHART_COLORS } from "../constants/chartColors";
import type { Candidate } from "@/components/candidates/types";

export interface SourceDistributionChartProps {
  candidates: Candidate[];
  data: Array<{ name: string; value: number }>;
}

// Define proper types for Recharts components
interface PieLabelProps {
  name: string;
  percent: number;
}

interface TooltipProps {
  active?: boolean;
  payload?: Array<{
    value: number;
    name: string;
  }>;
}

export const SourceDistributionChart = ({ data }: SourceDistributionChartProps) => {
  const COLORS = CHART_COLORS.primary;
  
  const renderCustomizedLabel = ({ name, percent }: PieLabelProps): string => {
    return `${name}: ${(percent * 100).toFixed(0)}%`;
  };

  const tooltipFormatter = (value: number): [string, string] => {
    return [value.toString(), 'Candidates'];
  };

  const tooltipLabelFormatter = (label: string): string => {
    return `Source: ${label}`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          nameKey="name"
          label={renderCustomizedLabel}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip 
          formatter={tooltipFormatter}
          labelFormatter={tooltipLabelFormatter}
        />
        <Legend 
          layout="horizontal" 
          verticalAlign="bottom" 
          align="center"
          wrapperStyle={{ paddingTop: '20px' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};
